import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const BundlePricingBoundsLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundlesPricingBounds } = await import("@workflows/bundles/configurations/pricing-bounds");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_PRICING_BOUNDS}>
      <BundlesPricingBounds />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
